// React
import React from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';

// Third party
import { useParams } from 'react-router-dom';

// Taxonomies
import { modelCore, modelDetail } from '../../../taxonomies/model';

// This component
export default function ModelDetail() {
  const { itemHash } = useParams();
  const isNewItem = itemHash === 'new';

  // Taxonomies
  const { endpoint, getDetailId, getDetailHash } = modelCore();
  const { baseUrl, getInputs } = modelDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'taxonomy',
        title: 'Model',
        // Static
        itemHash,
        isNewItem,
        endpoint,
        baseUrl,
        getDetailId,
        getDetailHash,
        getInputs,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
